/*
 * @Author: pengzhihui
 * @Description:
 * @Date: 2020-03-17 16:39:07
 * @LastEditTime: 2021-05-07 17:45:05
 */

import { appendStyle, isMobile, isSlowNetwork } from "./app";
import { MicroAppEntryConfigs } from "../interfaces";

const requestIdleCallback =
    window.requestIdleCallback ||
    function requestIdleCallback(cb: () => void) {
        return setTimeout(() => {
            cb();
        }, 1);
    };

export function prefetchCss(entryConfig: MicroAppEntryConfigs, appId: number) {
    const cssEntrys = entryConfig[appId].cssEntry;
    requestIdleCallback(() => {
        cssEntrys &&
            cssEntrys.forEach((cssEntry) => {
                appendStyle(cssEntry);
            });
    });
}

export function prefetchJs(entryConfig: MicroAppEntryConfigs, appId: number) {
    const jsEntrys = entryConfig[appId].jsEntry;
    requestIdleCallback(() => {
        jsEntrys &&
            jsEntrys.forEach((jsEntry) => {
                fetch(jsEntry).then((response) => {
                    response.text && response.text();
                });
            });
    });
}

export function prefetchAll(entryConfig: MicroAppEntryConfigs) {
    Object.keys(entryConfig).forEach((appId) => {
        // css需不需要预取待定,因为会造成样式污染
        // prefetchCss(entryConfig, appId);
        prefetchJs(entryConfig, Number(appId));
    });
}

export function prefetchResource(
    entryConfig: MicroAppEntryConfigs,
    match: ((location: any) => boolean) | boolean | undefined
) {
    if (isMobile || isSlowNetwork || !match) {
        return;
    }
    if (typeof match !== "function" || match(window.location)) {
        prefetchAll(entryConfig);
    }
}
